import { render, staticRenderFns } from "./GeneralForm.vue?vue&type=template&id=21182b0e&"
import script from "./GeneralForm.vue?vue&type=script&lang=js&"
export * from "./GeneralForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports